import actions from '@/store/modules/units/actions.js'
import cloneDeep from 'lodash/cloneDeep'
import state from '@/store/modules/units/state.js'
import mutations from '@/store/modules/units/mutations.js'
import getters from '@/store/modules/units/getters.js'

export default {
  actions,
  state: cloneDeep(state),
  mutations,
  getters,
}
